import {ApiException} from '@toolify/server/src/middleware/ApiResponseMiddleware/errors/ApiException'
import {KnownError} from '@toolify/server/src/middleware/ApiResponseMiddleware/types/KnownError'
import {PolicyLimitType} from '@toolify/server/src/models/mongoose/PlanModel/enum/PolicyLimitType'
import {policyLimitTypeTranslationKeyMap} from '@toolify/client/src/pages/WorkspaceSettings/constants/workspacePolicyLimitTypeMeta'
import {formatFileSizeFromMegabytes} from '@toolify/client/src/modules/files/helpers/formatFileSize'
import type {ComposerTranslation} from 'vue-i18n'

interface IPolicyLimitExceededExtra {
  policyLimitType?: PolicyLimitType
  limit?: number
  currentUsage?: number
}

export function isPolicyLimitExceededError(error: unknown): error is ApiException {
  return error instanceof ApiException && error.name === KnownError.POLICY_LIMIT_EXCEEDED
}

function formatPolicyLimitUsageValue(
  policyLimitType: PolicyLimitType,
  value: number,
): string | number {
  if (policyLimitType === PolicyLimitType.StorageMegabytes) {
    return formatFileSizeFromMegabytes(value)
  }
  return value
}

export function getPolicyLimitExceededToastMessage(
  error: ApiException,
  t: ComposerTranslation,
): string {
  const extra = error.extra as IPolicyLimitExceededExtra | undefined
  const policyLimitType = extra?.policyLimitType
  const limit = extra?.limit
  const currentUsage = extra?.currentUsage

  if (policyLimitType && policyLimitTypeTranslationKeyMap[policyLimitType]) {
    const limitName = t(policyLimitTypeTranslationKeyMap[policyLimitType])
    if (typeof limit === 'number' && typeof currentUsage === 'number') {
      return t('errors.policyLimitExceededWithUsage', {
        limitName,
        used: formatPolicyLimitUsageValue(policyLimitType, currentUsage),
        limit: formatPolicyLimitUsageValue(policyLimitType, limit),
      })
    }
    return t('errors.policyLimitExceeded', {limitName})
  }

  return t('errors.policyLimitExceededGeneric')
}
